import { Text } from '@tallink/components-lib'
import React from 'react'
import { useTranslation } from 'react-i18next'

import s from './PaymentDisclaimer.module.scss'

export default function PaymentDisclaimer() {
  const { t } = useTranslation()

  return (
    <Text className={s['payment-disclaimer']}>
      <p dangerouslySetInnerHTML={{ __html: t('payment.disclaimer') }} />
    </Text>
  )
}
